<div id="version-warning" *ngIf="versionCompatibility > 0">
  <h6 *ngIf="versionCompatibility == 2">Veralteter Server</h6>
  <h6 *ngIf="versionCompatibility == 1">Veraltete App</h6>
  <p>App-Version: {{version}} <br> Server-Version: {{generalSrv?.webConfig?.version}}</p>
</div>
